import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Toast, usePathParam } from '@chilecompra/react-kit'
import { USER_TYPE } from '../../config/settings/constant'
import { onGetPDFFilePrivateThunk, onGetPDFFilePublicThunk } from './EnrollmentCertificateSection.actions'
import { Column, ImageDownload, ButtonGrayLink } from './EnrollmentCertificateButton.styles'
import { Spinner } from '@chilecompra/react-kit/components'

/**
 * The File PDF Button container.
 */
const FilePDFButton = props => {
  const { error, loading } = useSelector(state => state.basicSellerInformation)
  const { error: summaryError } = useSelector(state => state.summarySection)
  const dispatch = useDispatch()
  const {
    pdfDownload: { error: errorDownload, loading: downloading }
  } = useSelector(state => state.enrollmentCertificate)
  const dni = usePathParam('rut')

  const handleClick = useCallback(() => {
    if (props?.userType === USER_TYPE.PUBLIC) {
      if (props.token) {
        dispatch(onGetPDFFilePublicThunk({ dni, token: props.token }))
      }
    } else {
      return dispatch(onGetPDFFilePrivateThunk({ dni }))
    }
  }, [props, downloading, loading])

  return loading || error || summaryError?.reason === 'FORBIDDEN_ERROR' ? null : (
    <>
      <Column margin="0 0 0.5rem 0" padding="0">
        <ButtonGrayLink color="secondary" variant="outlined" width="100%" onClick={handleClick} disabled={downloading}>
          {downloading ? (
            <Spinner />
          ) : (
            <>
              <ImageDownload alt="" />
              Descargar ficha en formato PDF
            </>
          )}
        </ButtonGrayLink>
      </Column>
      {errorDownload && !downloading && (
        <Toast
          align="left"
          border
          margin="12px 0"
          textDirection="vertical"
          title="Lo sentimos, estamos presentando problemas con nuestro servidor"
          severity="error"
        >
          En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos
          más.
        </Toast>
      )}
    </>
  )
}

FilePDFButton.propTypes = {
  userType: PropTypes.string,
  token: PropTypes.string
}

export default FilePDFButton
